import { Component, ElementRef, HostListener, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { LessonNavigationInfo } from '../../models/lesson-navigation-info.model';
import { CourseNavigationService } from '../../services/course-navigation.service';
import { DwInputConverter, booleanConverter } from '@devwareapps/devware-cap';

@Component({
  selector: 'app-lesson-navigation',
  template: `
  
    <div class="lesson-nav-container" [ngStyle]="navigationStyle" *ngIf="false">
      <div class="lesson-details-center">
        <button class="btn btn-primary" (click)="previous()" *ngIf="lessonNavigationInfo?.previousLesson && !lessonNavigationInfo.isFirstLesson">Previous</button>
        <button class="btn btn-primary" (click)="previous()" *ngIf="lessonNavigationInfo?.previousLesson && lessonNavigationInfo.isFirstLesson" >Previous</button>
        <ng-content select="[lessonDetails]"></ng-content>
        <button class="btn btn-primary" (click)="next()" *ngIf="lessonNavigationInfo?.nextLesson && !disableNext && !lessonNavigationInfo.isLastLesson">Next</button>
        <button class="btn btn-primary" (click)="next()" *ngIf="lessonNavigationInfo?.nextLesson && !disableNext && lessonNavigationInfo.isLastLesson">Next</button>
      </div>
    </div>
    <div class="lesson-nav-container" [ngStyle]="navigationStyle" *ngIf="true">
      <div class="lesson-previous">
        <button class="btn btn-primary" (click)="previous()" *ngIf="lessonNavigationInfo?.previousLesson && !lessonNavigationInfo.isFirstLesson">Previous</button>
        <button class="btn btn-primary" (click)="previous()" *ngIf="lessonNavigationInfo?.previousLesson && lessonNavigationInfo.isFirstLesson" >Previous</button>
      </div>
      <div class="lessonD-details">
          <ng-content select="[lessonDetails]"></ng-content>
      </div>
      <div class="lesson-next">
        <ng-content select="[lessonNext]"></ng-content>
        <button class="btn btn-primary" (click)="next()" *ngIf="lessonNavigationInfo?.nextLesson && !disableNext && !lessonNavigationInfo.isLastLesson">Next</button>
        <button class="btn btn-primary" (click)="next()" *ngIf="lessonNavigationInfo?.nextLesson && !disableNext && lessonNavigationInfo.isLastLesson">Next</button>
      </div>
    </div>
  `
})
export class LessonNavigationComponent implements OnInit, OnChanges {
  @Input() lessonNavigationInfo: LessonNavigationInfo;

  @DwInputConverter(booleanConverter)
  @Input() disableNext: boolean = false;
  width: any;
  height: number;
  finalWidth: string;
  navigationStyle: any;

  @Input() videoWidth: string;

  constructor(private courseNavigationService: CourseNavigationService,
    private elementRef: ElementRef
  ) { }


  ngOnInit(): void {
    this.setNavigationStyle();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.setNavigationStyle();
  }

  previous() {
    this.courseNavigationService.navigateToLesson(this.lessonNavigationInfo.previousLesson);
  }

  next() {
    if (this.lessonNavigationInfo.isLastLesson) {
      this.courseNavigationService.navigateToModule(this.lessonNavigationInfo.course?.CourseId, this.lessonNavigationInfo.nextLesson?.moduleId)
      return;
    }

    this.courseNavigationService.navigateToLesson(this.lessonNavigationInfo.nextLesson);
  }


  @HostListener('window:resize', ['$event'])
  public reset(event: any): void {
    // re-configure the grid style upon browser resize
    this.setNavigationStyle();
  }

  aspectRatio: number = 16 / 9;

  setNavigationStyle() {

    if (this.videoWidth) {
      this.navigationStyle = {
        'width': this.videoWidth,
      };
    } else {
      this.navigationStyle = {
        'max-width': '1200px'
      };
    }
  }

}
